import React from "react";

const LOGO_SRC = "/logo/strive-logo.png?v=5";

// Drop-shadow keeps the logo readable on any background (light hero sky,
// dark scrolled nav, dark footer).
const LOGO_FILTER =
  "drop-shadow(0 1px 2px rgba(0,0,0,0.9)) drop-shadow(0 6px 20px rgba(0,0,0,0.6))";

export const CarLogo = ({ className = "", height = 44 }) => (
  <img
    src={LOGO_SRC}
    alt=""
    aria-hidden="true"
    draggable={false}
    style={{ height, filter: LOGO_FILTER }}
    className={`w-auto select-none ${className}`}
  />
);

export const Wordmark = ({ className = "", height = 56 }) => (
  <div className={`flex items-center ${className}`}>
    <img
      src={LOGO_SRC}
      alt="Strive Motors"
      draggable={false}
      style={{ height, filter: LOGO_FILTER }}
      className="w-auto select-none"
    />
  </div>
);
